import React from 'react'
import { Box, Skeleton } from '@mui/material'

const Layover = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                bgcolor: 'neutral.100',
                borderRadius: '8px',
                px: 2,
                py: 1.5,
                my: 2,
                justifyContent: 'center'
            }}
        >
            <Skeleton variant="text" width={200} height={16} />
        </Box>
    )
}

export default Layover
